import listRoutes from './routes'

/* @ngInject */
const dispatchRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(listRoutes.index.path, {
      url: listRoutes.index.url,
      template: require('./templates/index.html'),
      controller: 'listCtrl',
      redirectTo: listRoutes.home.path,
    })
    .state(listRoutes.home.path, {
      url: listRoutes.home.url,
      template: require('./templates/home.html'),
    })
}

export default dispatchRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/list/list.routes.js